import Api from "@/services/service-v2";

export const createAccessrule = (payload) =>
  Api().$http.post(`/subscription-payments/access-rules`, payload);

export const fetchAccessRuleList = () =>
  Api().$http.get(`/subscription-payments/access-rules`);

export const editAccessrule = (payload) =>
  Api().$http.post(`/subscription-payments/access-rules/${payload.id}`, payload.data);
